import { utils } from '@hh/global.js'

const { prefersReducedMotion, fadeInAnimation } = utils

class HHGridFadeInItems extends HTMLElement {
  connectedCallback() {
    this.items = this.querySelectorAll('.js-grid-fade-in')

    if (!prefersReducedMotion()) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.init()
          }
        })
      })
      this.observer.observe(this)
    }
  }

  disconnectedCallback() {
    if (!prefersReducedMotion()) {
      this.observer.disconnect()
    }
  }

  init() {
    fadeInAnimation(this.items)
  }
}

customElements.define('hh-grid-fade-in-items', HHGridFadeInItems)
